import type { Notification } from '@kainos/validation';
import { http } from '@/lib/api';
import { config } from '@/lib/config';
import { mockApi } from '@/mocks/mock-api';

/**
 * The signed-in person's notifications, newest first.
 *
 * The API caps the list at the tray size, so there is no pagination to expose:
 * a bell is a list of recent exceptions, and anything older is answered by the
 * screen it points at.
 */
export function getNotifications(): Promise<Notification[]> {
  if (config.useMocks) return mockApi.listNotifications();

  return http.get<Notification[]>('/notifications');
}

/** Marks one notification read (or unread). Always goes to the API. */
export function markNotificationRead(notificationId: string, read = true): Promise<void> {
  return http.patch<void>(`/notifications/${notificationId}`, { read });
}

/** Clears the badge in one call, so the count is never stuck above zero. */
export function markAllNotificationsRead(): Promise<{ updated: number }> {
  return http.post<{ updated: number }>('/notifications/read-all');
}
